module.exports = __webpack_public_path__ + "img/share_upload_icon.c471ac23.svg";